import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import "./components/main/common/css/app.css";

import UI from "./actions/ui-helper";
import API from "./actions/api-helper";
import StringUtil from "./actions/string";
import Loader from "./components/loader/Loader";

import Login from "./components/acesso/Login";
import Main from "./components/main/Main";

import ImpressaoReuniao from "./components/main/relatorio/ImpressaoReuniao";
import ImpressaoApuracao from "./components/main/relatorio/ImpressaoApuracao";
import ImpressaoResumo from "./components/main/relatorio/ImpressaoResumo";
import ImpressaoProducao from "./components/main/relatorio/ImpressaoProducao";
import ImpressaoProntuario from "./components/main/relatorio/ImpressaoProntuario";
import ImpressaoAtendimento from "./components/main/relatorio/ImpressaoAtendimento";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { pronto: false, conectado: false, usuario: {} };
    this.updateUsuario = this.updateUsuario.bind(this);
    this.updateEmpresa = this.updateEmpresa.bind(this);
  }

  formatarEmpresa(empresa) {
    empresa.cnpj = StringUtil.mask(empresa.cnpj, "99.999.999/9999-99");
    empresa.endereco.cep = StringUtil.mask(empresa.endereco.cep, "99.999-999");
    empresa.telefoneComercial = StringUtil.mask(
      empresa.telefoneComercial,
      "(99) 9999-9999"
    );
    empresa.telefoneCelular = StringUtil.mask(
      empresa.telefoneCelular,
      "(99) 9999-9999"
    );
    return empresa;
  }

  updateUsuario(usuarioUpdated) {
    if (usuarioUpdated.id === this.state.usuario.id || usuarioUpdated.emulado) {
      this.setState({ usuario: usuarioUpdated });
    }
  }

  updateEmpresa(empresaUpdated) {
    if (empresaUpdated.id === this.state.usuario.empresa.id) {
      let usuarioUpdated = this.state.usuario;
      usuarioUpdated.empresa = this.formatarEmpresa(empresaUpdated);
      this.setState({ usuario: usuarioUpdated });
    }
  }

  componentDidMount() {
    // Parar emulação ao atualizar página
    localStorage.removeItem("emulado_accessToken");
    UI.loader("show", "Iniciando aplicação...");
    API.get("/acesso/perfil")
      .then((json) => {
        json.data.empresa = this.formatarEmpresa(json.data.empresa);
        UI.loader("hide");
        this.setState({ pronto: true, usuario: json.data });
      })
      .catch((json) => {
        this.setState({ pronto: true, usuario: false });
        UI.loader("hide");
      });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.pronto && (
          <Switch>
            {!this.state.usuario && <Route path="/" component={Login} />}
            <Route exact path="/login" component={Login} />
            <Route
              path="/impressao/atendimento/:id"
              render={({ match }) => (
                <ImpressaoAtendimento
                  usuario={this.state.usuario}
                  match={match}
                />
              )}
            />
            <Route
              path="/impressao/reuniao/:id"
              render={({ match }) => (
                <ImpressaoReuniao usuario={this.state.usuario} match={match} />
              )}
            />
            <Route
              path="/impressao/prontuario/:id"
              render={({ match, location }) => (
                <ImpressaoProntuario
                  usuario={this.state.usuario}
                  match={match}
                  location={location}
                />
              )}
            />
            <Route
              path="/impressao/apuracao"
              render={({ match, location }) => (
                <ImpressaoApuracao
                  usuario={this.state.usuario}
                  match={match}
                  location={location}
                />
              )}
            />
            <Route
              path="/impressao/resumo"
              render={({ match, location }) => (
                <ImpressaoResumo
                  usuario={this.state.usuario}
                  match={match}
                  location={location}
                />
              )}
            />
            <Route
              path="/impressao/producao"
              render={({ match, location }) => (
                <ImpressaoProducao
                  usuario={this.state.usuario}
                  match={match}
                  location={location}
                />
              )}
            />
            <Route
              path="/"
              render={() => (
                <Main
                  usuario={this.state.usuario}
                  onUpdateUsuario={this.updateUsuario}
                  onUpdateEmpresa={this.updateEmpresa}
                />
              )}
            />
          </Switch>
        )}
        <Loader />
      </React.Fragment>
    );
  }
}

export default App;
